import { httpInstance } from '@/clients/http.request';
import { urlMailBackend } from '@/helpers';

export const enviarConsultaScore = async ({ commit, rootState }, payload) => {
   commit('setScoreLoading', true);
   commit('setScoreEnviado', false);

   try {
      const idPoliza = rootState?.poliza?.poliza?.id_poliza || null;
      const simulador = rootState?.creditos?.simuladorForm || {};
      const cuotas = rootState?.creditos?.simulacionResultado || [];
      const hasSimuladorData =
         !!simulador?.linea ||
         simulador?.valorVehiculo != null ||
         simulador?.anioVehiculo != null ||
         simulador?.montoAFinanciar != null ||
         simulador?.capital != null ||
         simulador?.plazo != null ||
         !!simulador?.fechaPrimerVencimiento;
      const response = await httpInstance.post(
         `${urlMailBackend}/sendEmailCreditosScore`,
         {
            id_poliza: idPoliza,
            ...payload,
            simulador,
            cuotas,
            documentacionSeleccionada: hasSimuladorData
               ? payload?.documentacionSeleccionada || []
               : [],
         },
      );

      commit('setScoreEnviado', true);
      return response?.data || { success: true };
   } catch (error) {
      throw error;
   } finally {
      commit('setScoreLoading', false);
   }
};

export const enviarSimulacionCreditoMail = async ({ rootState }, payload) => {
   const idPoliza = rootState?.poliza?.poliza?.id_poliza || null;
   const scoreForm = rootState?.creditos?.scoreForm || {};
   const response = await httpInstance.post(
      `${urlMailBackend}/sendEmailCreditosSimulacion`,
      {
         id_poliza: idPoliza,
         ...scoreForm,
         ...payload,
      },
   );

   return response?.data || { success: true };
};
